<template>
	<!-- 页面实际内容路由出口 -->
	<div style="height: 100%;position: relative;width: 100%;overflow-y: auto;box-shadow: 0px 0px 15px 0px #ececec;">
		<router-view v-slot="{ Component }">
			<keep-alive>
				<Transition name="router_view_transition">
					<component :is="Component" style="width: 100%;height: 100%;" />
				</Transition>
			</keep-alive>
		</router-view>
	</div>
</template>

<script>
</script>

<style scoped lang="less">
	.router_view_transition-move,
	/* 对移动中的元素应用的过渡 */
	.router_view_transition-enter-active,
	.router_view_transition-leave-active {
		transition: all 0.2s ease;
	}

	.router_view_transition-enter-from,
	.router_view_transition-leave-to {
		opacity: 0;
		transform: translateX(20px);
	}

	.router_view_transition-enter-active,
	.router_view_transition-leave-active {
		position: absolute;
	}
</style>